// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"648cf160","977":"05756e62"}[chunkId] + ".chunk.js";
};